import { z } from 'zod';

export type BankDocumentType = 'CC' | 'CCS' | 'BS' | null;

export const bankUploadEndCallbackSchema = z.enum(['RECHARGE']);
export type BankUploadEndCallback = z.infer<typeof bankUploadEndCallbackSchema>;
